import axiosInstance from './axiosConfig';
import { Category, SubCategory } from '../types/catalog';

export const fetchCategories = async (): Promise<Category[]> => {
  const response = await axiosInstance.get('/categories');
  return response.data.map((category: any) => ({
    id: category._id,
    name: category.name,
    description: category.description,
    image: category.imageUrl,
    order: category.order
  }));
};

export const fetchSubcategoriesByCategory = async (categoryId: string): Promise<SubCategory[]> => {
  const response = await axiosInstance.get(`/subcategories/category/${categoryId}`);
  return response.data.map((subcategory: any) => ({
    id: subcategory._id,
    categoryId: subcategory.categoryId,
    name: subcategory.name,
    shortDescription: subcategory.shortDescription,
    fullDescription: subcategory.fullDescription,
    image: subcategory.image,
    manufacturer: subcategory.manufacturer,
    characteristics: subcategory.characteristics?.map((char: any) => ({
      name: char.name,
      type: char.type,
      value: char.value,
      fileUrl: char.fileUrl,
      videoUrl: char.videoUrl
    })) || [],
    documents: subcategory.documents?.map((doc: any) => ({
      id: doc._id,
      name: doc.name,
      type: doc.type,
      fileUrl: doc.fileUrl,
      videoUrl: doc.videoUrl
    })) || [],
    order: subcategory.order,
    price: subcategory.price
  }));
};

export const updateSubcategory = async (id: string, formData: FormData): Promise<SubCategory> => {
  const response = await axiosInstance.patch(`/subcategories/${id}`, formData);
  const subcategory = response.data;
  return {
    id: subcategory._id,
    categoryId: subcategory.categoryId,
    name: subcategory.name,
    shortDescription: subcategory.shortDescription,
    fullDescription: subcategory.longDescription,
    image: subcategory.imageUrl,
    manufacturer: subcategory.producer,
    characteristics: subcategory.characteristics,
    documents: subcategory.documentation,
    order: subcategory.order,
    price: subcategory.price
  };
}; 